<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
body{
  /* background-color: #F6F8FF; */
  margin: 0;
  padding: 12px
}
#app {
  font-family: 'Microsoft YaHei', 'Avenir', Helvetica, Arial, sans-serif;
  color: #222;
  font-size: 14px;
}
a {
  color: #333;
  text-decoration: none;
}
a:hover {
  color: #0f9fff;
}
ul, li{
  list-style: none;
}
i, em{
  font-style: normal;
}
.revert{
  cursor: revert!important;
}
.revert:hover{
  color: #333!important;
  text-decoration: none!important;
}
/*滚动条*/
::-webkit-scrollbar-track-piece {
  background-color: #fff;
}

::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-thumb {
  background-color: #ccc;
  background-clip: padding-box;
  min-height: 28px;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #ddd;
}
.drawer-detail .el-drawer__open .el-drawer{
  overflow: auto!important;
}
.drawer-detail .el-drawer__header{
  font-size: 20px;
  color: #000;
  margin-bottom: 10px!important;
}
.drawer-detail .el-drawer__body{
    word-break: break-word;
    line-height: 1.7;
    padding:  0 20px;
    color: #111;
    font-size: 16px;
}
.drawer-detail .el-drawer__body div h3:nth-child(1){
  margin-top: 0!important;
}
.drawer-detail .el-drawer__body p{
  margin-top: 0!important;
}
.j-desc{
  background: #f5f5f5;
  border: 1px solid #ddd;
  padding: 15px 15px 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue